import { render } from "./index.vue?vue&type=template&id=9c013f2a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=9c013f2a&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c013f2a"],['__file',"src/views/widget/shop/carousel/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c013f2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c013f2a', __exports__)) {
    console.log('reload')
    api.reload('9c013f2a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=9c013f2a&scoped=true", () => {
    console.log('re-render')
    api.rerender('9c013f2a', render)
  })

}


export default __exports__